module.exports = __webpack_public_path__ + "static/enterprise_header-ed806f5272ab4e06468de4f10f5f6434.png";